// extracted by mini-css-extract-plugin
export default {"Logo--fullscreen":"Access_Logo--fullscreen__boB+X"};